import routes from './routes'
import { createRouter, createWebHistory } from 'vue-router'
import store from '../store/index'
import i18n from '../i18n'
import { ElMessage } from 'element-plus'

const isProduction = process.env.NODE_ENV === 'production'

// 3. 创建路由实例并传递 `routes` 配置
// 你可以在这里输入更多的配置，但我们在这里
// 暂时保持简单
const router = createRouter({
  history: createWebHistory(isProduction ? '/customerui/' : '/'),
  routes
})

// ChunkLoadError 兜底：懒加载分包失败时尝试刷新，避免页面白屏
router.onError((error) => {
  const isChunkError =
    /Loading chunk [\d]+ failed/i.test(error?.message || '') ||
    /ChunkLoadError/i.test(error?.name || '') ||
    /Failed to fetch dynamically imported module/i.test(error?.message || '')

  if (!isChunkError) {
    throw error
  }

  const reloaded = sessionStorage.getItem('chunk-reload')
  if (!reloaded) {
    sessionStorage.setItem('chunk-reload', '1')
    window.location.reload()
    return
  }

  sessionStorage.removeItem('chunk-reload')
  ElMessage.error(i18n.global.t('common.chunk_load_error_tip'))
})

router.beforeEach((to, from, next) => {
  if (document.documentElement.clientWidth <= 600) {
    store.commit('CLOSE_SLIDEBAR')
  }
  var uid = localStorage.getItem("uid");
  var token = localStorage.getItem("utn");
  var firstLogin = localStorage.getItem("firstLogin");
  if ( to.path == '/login') {
    if ( uid && token ) {
      if (firstLogin === 'true') {
        next({path:'/firstLogin'})
      } else {
        next({path:'/'})
      }
    }
    next();
  } else if (to.path == '/firstLogin') {
    if ( uid && token ) {
      next();
    } else {
      next({path:'/'})
    }
  } else {
    if (to.meta.requiresAuth) {
      if ( uid && token ) {
        if (firstLogin === 'true') {
          next({
            path: '/firstLogin',
          })
        } else {
          store.dispatch('getCurrentPageName', to.name)
          next()
        }
      }
      else {
        next({
          path: '/login',
          query: {redirect: to.fullPath}
        })
      }
    } else {
      store.dispatch('getCurrentPageName', to.name)
      next()
    }
  }
})

export default router
